
import {Component, Vue, Prop} from 'vue-property-decorator';
import {Empty} from 'ant-design-vue';

@Component({
    components: {
        Empty
    }
})
export default class NoData extends Vue {}
